import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentVerifiedFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21 9c0-6-2-8-8-8H3v22h18zm-4.5-1.273L17.773 9 10.5 16.273 6.227 12 7.5 10.727l3 3z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentVerifiedFilledSize24Glyph.displayName = 'DocumentVerifiedFilledSize24Glyph';
